import { Link, useLocation } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { WarningOutlined } from '@ant-design/icons';
import { useAuth } from 'hooks/useAuth';
import { routes } from 'config/config';
import { StyledFarmNotPublicBanner } from './style';

const FarmNotPublicBanner = () => {
  const { user } = useAuth();
  const intl = useIntl();
  const { pathname } = useLocation();

  const farm = user?.farm;
  if (!user?.farmId || !farm || farm.public !== false) {
    return null;
  }

  const businessUrl = routes.admin.adminBusiness;
  const sectionLabel = intl.formatMessage({ id: 'navigation.company_info' });
  const isOnBusinessPage = pathname === businessUrl;

  return (
    <StyledFarmNotPublicBanner role="status" data-testid="farm-not-public">
      <WarningOutlined />
      <span>
        <FormattedMessage
          id="company.not_public_banner"
          values={{
            link: isOnBusinessPage ? (
              <strong>{sectionLabel}</strong>
            ) : (
              <Link to={businessUrl}>{sectionLabel}</Link>
            ),
          }}
        />
      </span>
    </StyledFarmNotPublicBanner>
  );
};

export default FarmNotPublicBanner;
